<template>
  <div id="pc" ref="scrollElement" >
    <navBar
      id="navigation"
      ref="navbar"
    ></navBar>
    <div id="nav_1">
      <banner-view ></banner-view>
      <yc-game></yc-game>
    </div>
    
    <div id="nav_2">
      <hz-flow ></hz-flow>
      <hz-clause></hz-clause>
    </div>
    <yq-Js id="nav_3"></yq-Js>
    <div id="nav_4">
      <business></business>
      <hz-Case></hz-Case>
    </div>
    <sq-show id="nav_5"></sq-show>
    <!-- 游戏专区 -->
    <game-single id="nav_6"></game-single>
    <download @guideopen="guideopen" id="nav_7"></download>

    <!-- 悬浮弹窗 -->
    <div class="fixed fixednvs" id="btnScrollToTop">
      <div class="fixed_enterinto">
        <a href="https://www.qn000.com/#/" target="_blank">
          <div class="fixed_enterinto_img"></div>
        </a>
      </div>

      <div data-scroll-id="wap_2" @click="basescroll('#nav_2')">
        <div class="fixed-li">
          <div class="fixed-li_1"></div>
          <div>合作</div>
        </div>
      </div>
      <div @click="downloadA(kfUrl)">
        <div class="fixed-li">
          <div class="fixed-li_4"></div>
          <div>客服</div>
        </div>
      </div>
      <div data-scroll-id="wap_7" @click="basescroll('#nav_7')">
        <div class="fixed-li">
          <div class="fixed-li_2"></div>
          <div>下载</div>
        </div>
      </div>
     
      <div class="recur" data-scroll-id="wap_1" @click="scrollToTop">
        <div class="fixed-li">
          <div class="fixed-li_3"></div>
        </div>
      </div>
    </div>
    <!-- 下载引导页 -->
    <guide ref="guideopen"></guide>
  </div>
</template>

<script>
// yinqing页面
import navBar from "./pc_components/navBar.vue";
import BannerView from "./pc_components/bannerView.vue";
import ycGame from "./pc_components/ycGame.vue";
import hzFlow from "./pc_components/hzFlow.vue";
import hzClause from "./pc_components/hzClause.vue";
import yqJs from "./pc_components/yqJs.vue";
import business from "./pc_components/business.vue";
import hzCase from "./pc_components/hzCase.vue";
import sqShow from "./pc_components/sqShow.vue";
import gameSingle from "./pc_components/gameSingle.vue";
import download from "./pc_components/download.vue";
import { navMapScroll,selectScroll } from "@/utils/scroll";
import { downloadA,kfUrl } from "@/utils/download";

import Guide from '@/components/guide/guide';
export default {
  name: "pc",
  components: {
    navBar,
    // NewCenter,
    // HotGame,
    // NewGame,
    // RankGame,
    // AboutUs,
    // DownloadGame,
    BannerView,
    ycGame,
    hzFlow,
    hzClause,
    yqJs,
    business,
    hzCase,
    sqShow,
    gameSingle,
    download,
    Guide
  },
  data() {
    return {
      navbarHeight: 0,
      showNewCenter: true,
      popShow: false,
      kfUrl:kfUrl
    };
  },
  created() {},
  mounted() {
    window.addEventListener("scroll", this.scrollFunction);
    this.monitor();
    this.initScroll()
  },
  watch: {},
  methods: {
    downloadA,
    guideopen(){
       this.$refs.guideopen.show = true;
    },
    initScroll(){
      this.$nextTick(()=>{
      let nav_box = document.querySelector(".nav_box");
      navMapScroll("activate", nav_box.querySelectorAll(".nav"),'nav_');
    })
    },
    basescroll(name){
      let idName = document.querySelector(name)
      selectScroll(idName)
    },
    
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    },
    scrollFunction() {
      if (
        (document.body.scrollTop > 600 ||
          document.documentElement.scrollTop > 600) &&
        document.getElementById("btnScrollToTop")
      ) {
        document.getElementById("btnScrollToTop").style.visibility = "visible";
      } else {
        if (document.getElementById("btnScrollToTop"))
          document.getElementById("btnScrollToTop").style.visibility = "hidden";
      }
      // console.log(document.documentElement.scrollTop, "2")
    },
    monitor() {
      let _this = this;
      const intersectionObserver = new IntersectionObserver(
        (entries) => {
          // 如果 intersectionRatio 为 0，则目标在视野外，
          if (
            entries[0].intersectionRatio > 0 &&
            document.documentElement.clientWidth <= 1920
          ) {
            entries[0].target.classList.add("animate__bounceInLeft");
          }
          if (
            entries[0].target.id != "download" ||
            entries[0].target.id != "wap_5"
          ) {
            _this.pcqrShow = false;
            _this.saveShow = false;
          }
          if (entries[0].intersectionRatio <= 0) return;
          // 开始监听
        },
        {
          // threshold: [0, 0.25, 0.5, 0.75, 1]
          threshold: 0.3,
        }
      );

      // intersectionObserver.observe(document.querySelector(".navigation"))
      intersectionObserver.observe(document.querySelector(".original"));
      intersectionObserver.observe(document.querySelector(".flowx"));
      intersectionObserver.observe(document.querySelector(".box_introduce"));
      intersectionObserver.observe(document.querySelector(".business"));
      intersectionObserver.observe(document.querySelector(".case"));
      intersectionObserver.observe(document.querySelector(".attract"));
      intersectionObserver.observe(document.querySelector(".download "));
      intersectionObserver.observe(document.querySelector(".game_Single "));
    },
  },
};
</script>

<style scoped lang="scss">
@import url('../assets/css/pc');
.red {
  color: red;
}

.fixed {
  width: 0.85rem /* 68/80 */;
  height: 3.65rem /* 292/80 */;
  height: 4.5625rem /* 365/80 */;
  position: fixed;
  right: 2.0125rem /* 161/80 */;
  top: 50%;
  transform: translateY(-50%);
  background: #ffffff;
  box-shadow: 0px 0.0375rem 0.0625rem 1px rgba(124, 124, 124, 0.6);
  border-radius: 0.125rem /* 10/80 */;
  display: flex;
  flex-direction: column;
  z-index: 2;
  z-index: 4;
}

.fixed > div {
  flex: 1;
  color: #555555;
  font-size: 0.175rem;
  display: flex;
  border-bottom: 1px dashed #9a9a9a;
  cursor: pointer;
}

.fixed .fixed_enterinto {
  /* flex-shrink: 0;
flex: auto; */

  position: relative;
}
.fixed .fixed_enterinto_img {
  position: absolute;
  top: -0.05rem /* 4/80 */;
  left: 50%;
  transform: translateX(-50%);
  width: 1.2rem /* 96/80 */;
  height: 0.825rem /* 66/80 */;
  background: url("../assets/images/pc/pc_yq.gif") no-repeat;
  background-size: cover;
}
.fixed > div:nth-child(1) {
  border: none;
}
.fixed > div:last-child {
  border: none;
}

.fixed .fixed-li {
  margin: auto;
  text-align: center;
}

.fixed .fixed-li > div:nth-child(1) {
  margin: 0 auto;
  background-size: cover;
}
.fixed .fixed-li > div:nth-child(2) {
  color: #555555 !important;
  margin-top: 0.1rem /* 8/80 */;
}

.fixed .fixed-li_1 {
  width: 0.3875rem;
  height: 0.3875rem;
  background: url("../assets/images/pc/fiend_1.png") no-repeat center;
}
.fixed .fixed-li_4 {
  width: .325rem /* 26/80 */;
  height: .325rem /* 26/80 */;
  background: url("../assets/images/pc/fiend_4.png") no-repeat center;
}
.fixed .fixed-li_2 {
  width: 0.3rem;
  height: 0.275rem;
  background: url("../assets/images/pc/fixed_2.png") no-repeat center;
  background-image: 24px 22px;
  margin: 0 auto;
}

.fixed .fixed-li_3 {
  width: 0.325rem;
  height: 0.4125rem;
  background: url("../assets/images/pc/fixed_3.png") no-repeat center;
}
</style>
